import { render, staticRenderFns } from "./LegisDb.vue?vue&type=template&id=5298f75d&scoped=true"
import script from "./LegisDb.vue?vue&type=script&lang=js"
export * from "./LegisDb.vue?vue&type=script&lang=js"
import style0 from "./LegisDb.vue?vue&type=style&index=0&id=5298f75d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_cache-loader@4.1.0_webpack@4.47.0__css-load_7907ed7515d572276d45114f834f04a7/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5298f75d",
  null
  
)

export default component.exports